

import { Alignment, Fit, Layout, useRive } from "@rive-app/react-canvas";

type VideoPlayerRivProps = {
  videoName: string;
  width?: string;
  height?: string;
};

export const VideoPlayerRivInner: React.FC<VideoPlayerRivProps> = ({
  videoName,
  width = "w-35 sm:w-45 lg:w-55",
  height = "h-35 sm:h-45 lg:h-55",
}) => {
  const { RiveComponent } = useRive({
    src: `/riv/${videoName}.riv`,
    autoplay: true,
    stateMachines: "State Machine 1",
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.Center,
    }),
  });

  return (
    <div className={`${width} ${height}`}>
      <RiveComponent />
    </div>
  );
};
